export default __webpack_public_path__ + "static/media/toyota.c4e6bb81.svg";